import { RtText } from '@dpa/react-text';
import { RtFrame } from '@dpa/react-frame-pulse';
import classnames from 'classnames/bind';
import { TResponseDataToOptions } from '../../../../_utils/transform-response-data-to-options/_types';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'Dropdown-option';

type TProps = {
  searchingText: string;
  option: TResponseDataToOptions;
  onChange: (value: TResponseDataToOptions) => void;
};

export const DropdownOption = ({ searchingText, option, onChange }: TProps) => {
  const subLabel = option.subLabel || '';
  const query = searchingText.trim();
  const index = query
    ? subLabel.toLowerCase().indexOf(query.toLowerCase())
    : -1;
  const hasMatch = index !== -1;

  const handleClick = () => onChange(option);

  const beforeMatch = hasMatch ? subLabel.slice(0, index) : subLabel;
  const matchText = hasMatch ? subLabel.slice(index, index + query.length) : '';
  const afterMatch = hasMatch ? subLabel.slice(index + query.length) : '';

  return (
    <RtFrame
      className={cn(BLOCK_NAME)}
      surface="foundation-pure"
      use="cloudy"
      onClick={handleClick}
    >
      {beforeMatch && (
        <RtText specification="main" typography="body-md-regular" as="span">
          <span>{beforeMatch}</span>
        </RtText>
      )}

      {matchText && (
        <RtText specification="main" typography="body-md-medium" as="span">
          <span>{matchText}</span>
        </RtText>
      )}

      {afterMatch && (
        <RtText specification="main" typography="body-md-regular" as="span">
          <span>{afterMatch}</span>
        </RtText>
      )}
    </RtFrame>
  );
};
